(function () {
  var instances = new WeakMap();

  function setHiddenAfterTransition(element, delay, callback) {
    window.setTimeout(function () {
      if (!element.classList.contains('is-open')) {
        element.hidden = true;
        if (callback) callback();
      }
    }, delay);
  }

  function syncBodyLock() {
    var hasOpenOverlay = document.querySelector(
      '.opgh__mobile-panel.is-open, .opgh__search-overlay.is-open'
    );
    document.body.classList.toggle('opgh-overlay-open', Boolean(hasOpenOverlay));
  }

  function focusableElements(container) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function trapFocus(event, elements) {
    if (event.key !== 'Tab' || !elements.length) return;

    var first = elements[0];
    var last = elements[elements.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function formatMoney(value, currency) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return '';

    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: currency || 'COP',
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) {
      return '$' + Math.round(amount).toLocaleString('es-CO');
    }
  }

  function optimizedImageUrl(source) {
    if (!source) return '';

    try {
      var imageUrl = new URL(source, window.location.origin);
      imageUrl.searchParams.set('width', '720');
      return imageUrl.toString();
    } catch (error) {
      return source;
    }
  }

  function createProductResult(product, currency) {
    var article = document.createElement('article');
    var link = document.createElement('a');
    var media = document.createElement('span');
    var title = document.createElement('span');
    var price = document.createElement('span');
    var featuredImage = product.featured_image;
    var imageSource = featuredImage && (featuredImage.url || featuredImage.src || featuredImage);

    article.className = 'opgh__result-card';
    link.href = product.url;
    link.setAttribute('aria-label', product.title);

    media.className = 'opgh__result-media';
    if (imageSource) {
      var image = document.createElement('img');
      image.src = optimizedImageUrl(imageSource);
      image.alt = product.featured_image && product.featured_image.alt ? product.featured_image.alt : product.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    }

    title.className = 'opgh__result-title';
    title.textContent = product.title;

    link.appendChild(media);
    link.appendChild(title);

    if (product.price !== undefined && product.price !== null) {
      var formattedPrice = formatMoney(product.price, currency);
      if (formattedPrice) {
        price.className = 'opgh__result-price';
        price.textContent = formattedPrice;
        link.appendChild(price);
      }
    }

    article.appendChild(link);
    return article;
  }

  function initHeader(header) {
    if (!header || instances.has(header)) return;

    var sectionId = header.dataset.opghSectionId;
    var menuTrigger = header.querySelector('[data-opgh-menu-toggle]');
    var searchTrigger = header.querySelector('[data-opgh-search]');
    var mobilePanel = document.querySelector('[data-opgh-mobile-panel="' + sectionId + '"]');
    var searchOverlay = document.querySelector('[data-opgh-search-overlay="' + sectionId + '"]');
    var searchClose = searchOverlay && searchOverlay.querySelector('[data-opgh-search-close]');
    var searchInput = searchOverlay && searchOverlay.querySelector('[data-opgh-search-input]');
    var quickLinks = searchOverlay && searchOverlay.querySelector('[data-opgh-quick-links]');
    var results = searchOverlay && searchOverlay.querySelector('[data-opgh-search-results]');
    var resultsGrid = searchOverlay && searchOverlay.querySelector('[data-opgh-results-grid]');
    var searchStatus = searchOverlay && searchOverlay.querySelector('[data-opgh-search-status]');
    var predictiveUrl = searchOverlay && searchOverlay.dataset.opghPredictiveUrl;
    var currency = searchOverlay && searchOverlay.dataset.opghCurrency;
    var mobileQuery = window.matchMedia('(max-width: 1024px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cleanup = [];
    var searchTimer;
    var searchRequest;
    var lastScrollY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    var scrollDirection = 0;
    var directionalTravel = 0;
    var scrollFrame;

    function listen(target, eventName, handler, options) {
      if (!target) return;
      target.addEventListener(eventName, handler, options);
      cleanup.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function syncHeaderOverlayState() {
      var isOpen = Boolean(
        (mobilePanel && mobilePanel.classList.contains('is-open')) ||
        (searchOverlay && searchOverlay.classList.contains('is-open'))
      );
      header.classList.toggle('is-overlay-open', isOpen);
      if (isOpen) {
        header.classList.remove('is-hidden');
      } else {
        lastScrollY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
        scrollDirection = 0;
        directionalTravel = 0;
      }
      syncBodyLock();
    }

    function updateHeaderForScroll() {
      scrollFrame = undefined;

      var currentScrollY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
      var delta = currentScrollY - lastScrollY;
      var isAtTop = currentScrollY <= 2;
      var overlayIsOpen = header.classList.contains('is-overlay-open');

      header.classList.toggle('is-scrolled', !isAtTop);

      if (isAtTop) {
        header.classList.remove('is-hidden');
        scrollDirection = 0;
        directionalTravel = 0;
        lastScrollY = currentScrollY;
        return;
      }

      if (Math.abs(delta) < 1) {
        lastScrollY = currentScrollY;
        return;
      }

      var nextDirection = delta > 0 ? 1 : -1;
      if (nextDirection !== scrollDirection) {
        scrollDirection = nextDirection;
        directionalTravel = 0;
      }
      directionalTravel += Math.abs(delta);

      if (overlayIsOpen) {
        header.classList.remove('is-hidden');
      } else if (nextDirection > 0 && currentScrollY > 96 && directionalTravel >= 18) {
        header.classList.add('is-hidden');
      } else if (nextDirection < 0 && directionalTravel >= 10) {
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
    }

    function onScroll() {
      if (scrollFrame !== undefined) return;
      scrollFrame = window.requestAnimationFrame(updateHeaderForScroll);
    }

    function closeMenu(restoreFocus, immediate) {
      if (!mobilePanel || !menuTrigger) return;

      mobilePanel.classList.remove('is-open');
      mobilePanel.setAttribute('aria-hidden', 'true');
      menuTrigger.setAttribute('aria-expanded', 'false');
      menuTrigger.setAttribute('aria-label', 'Abrir menú');
      header.classList.remove('is-menu-open');

      if (immediate) {
        mobilePanel.hidden = true;
        syncHeaderOverlayState();
      } else {
        setHiddenAfterTransition(mobilePanel, reducedMotion.matches ? 20 : 400, syncHeaderOverlayState);
      }
      if (restoreFocus) menuTrigger.focus();
    }

    function closeSearch(restoreFocus, immediate) {
      if (!searchOverlay || !searchTrigger) return;

      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchTrigger.setAttribute('aria-expanded', 'false');

      if (immediate) {
        searchOverlay.hidden = true;
        syncHeaderOverlayState();
      } else {
        setHiddenAfterTransition(searchOverlay, reducedMotion.matches ? 20 : 380, syncHeaderOverlayState);
      }
      if (restoreFocus) searchTrigger.focus();
    }

    function openMenu() {
      if (!mobilePanel || !menuTrigger) return;

      closeSearch(false, true);
      mobilePanel.style.setProperty(
        '--opgh-panel-top',
        (header.querySelector('.opgh__bar').offsetHeight || 108) + 'px'
      );
      mobilePanel.hidden = false;
      mobilePanel.setAttribute('aria-hidden', 'false');
      menuTrigger.setAttribute('aria-expanded', 'true');
      menuTrigger.setAttribute('aria-label', 'Cerrar menú');
      header.classList.add('is-menu-open');
      syncHeaderOverlayState();

      window.requestAnimationFrame(function () {
        mobilePanel.classList.add('is-open');
        window.requestAnimationFrame(function () {
          var focusables = focusableElements(mobilePanel);
          if (focusables.length) focusables[0].focus();
        });
      });
    }

    function openSearch() {
      if (!searchOverlay || !searchTrigger || !searchInput) return;

      closeMenu(false, true);
      searchOverlay.hidden = false;
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchTrigger.setAttribute('aria-expanded', 'true');
      syncHeaderOverlayState();

      window.requestAnimationFrame(function () {
        searchOverlay.classList.add('is-open');
        window.requestAnimationFrame(function () {
          searchInput.focus();
        });
      });
    }

    function showQuickLinks() {
      if (!quickLinks || !results || !resultsGrid || !searchInput) return;
      quickLinks.hidden = false;
      results.hidden = true;
      resultsGrid.replaceChildren();
      searchInput.setAttribute('aria-expanded', 'false');
      if (searchStatus) searchStatus.textContent = '';
    }

    function showSearchMessage(message) {
      if (!quickLinks || !results || !resultsGrid || !searchInput) return;
      quickLinks.hidden = true;
      results.hidden = false;
      resultsGrid.replaceChildren();

      var paragraph = document.createElement('p');
      paragraph.className = 'opgh__search-empty';
      paragraph.textContent = message;
      resultsGrid.appendChild(paragraph);
      searchInput.setAttribute('aria-expanded', 'true');
    }

    function renderProducts(products) {
      if (!resultsGrid || !searchStatus || !searchInput) return;
      resultsGrid.replaceChildren();

      if (!products.length) {
        showSearchMessage('No encontramos coincidencias. Prueba con otro nombre o categoría.');
        searchStatus.textContent = 'Sin resultados';
        return;
      }

      products.forEach(function (product) {
        resultsGrid.appendChild(createProductResult(product, currency));
      });

      searchStatus.textContent = products.length === 1 ? '1 producto' : products.length + ' productos';
      searchInput.setAttribute('aria-expanded', 'true');
    }

    function requestSuggestions(term) {
      if (!predictiveUrl || !term) return;

      if (searchRequest) searchRequest.abort();
      searchRequest = new AbortController();
      showSearchMessage('Buscando joyas...');
      if (searchStatus) searchStatus.textContent = 'Buscando';

      var endpoint = predictiveUrl.endsWith('.json') ? predictiveUrl : predictiveUrl + '.json';
      var url = new URL(endpoint, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[options][unavailable_products]', 'last');

      fetch(url.toString(), {
        headers: { Accept: 'application/json' },
        signal: searchRequest.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (payload) {
          var products =
            payload &&
            payload.resources &&
            payload.resources.results &&
            payload.resources.results.products;
          renderProducts(Array.isArray(products) ? products : []);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          showSearchMessage('No pudimos cargar las sugerencias. Puedes buscar presionando Enter.');
          if (searchStatus) searchStatus.textContent = 'Búsqueda disponible';
        });
    }

    function onSearchInput() {
      var term = searchInput.value.trim();
      window.clearTimeout(searchTimer);

      if (searchRequest) searchRequest.abort();
      if (term.length < 2) {
        showQuickLinks();
        return;
      }

      searchTimer = window.setTimeout(function () {
        requestSuggestions(term);
      }, 180);
    }

    function onDocumentKeydown(event) {
      if (event.key === 'Escape') {
        if (searchOverlay && searchOverlay.classList.contains('is-open')) {
          event.preventDefault();
          closeSearch(true, false);
        } else if (mobilePanel && mobilePanel.classList.contains('is-open')) {
          event.preventDefault();
          closeMenu(true, false);
        }
        return;
      }

      if (searchOverlay && searchOverlay.classList.contains('is-open')) {
        trapFocus(event, focusableElements(searchOverlay));
      } else if (mobilePanel && mobilePanel.classList.contains('is-open')) {
        trapFocus(event, [menuTrigger].concat(focusableElements(mobilePanel)));
      }
    }

    function onResize() {
      if (!mobileQuery.matches && mobilePanel && mobilePanel.classList.contains('is-open')) {
        closeMenu(false, true);
      }
      updateHeaderForScroll();
    }

    listen(menuTrigger, 'click', function () {
      if (mobilePanel && mobilePanel.classList.contains('is-open')) {
        closeMenu(true, false);
      } else {
        openMenu();
      }
    });

    listen(searchTrigger, 'click', function () {
      openSearch();
    });

    listen(searchClose, 'click', function () {
      closeSearch(true, false);
    });

    listen(searchInput, 'input', onSearchInput);
    listen(document, 'keydown', onDocumentKeydown);
    listen(window, 'resize', onResize);
    listen(window, 'scroll', onScroll, { passive: true });

    listen(mobilePanel, 'click', function (event) {
      if (event.target.closest('a[href]')) closeMenu(false, true);
    });

    updateHeaderForScroll();

    instances.set(header, function destroy() {
      cleanup.forEach(function (removeListener) {
        removeListener();
      });
      window.clearTimeout(searchTimer);
      if (scrollFrame !== undefined) window.cancelAnimationFrame(scrollFrame);
      if (searchRequest) searchRequest.abort();
      closeMenu(false, true);
      closeSearch(false, true);
      instances.delete(header);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-op-global-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var header = event.target.querySelector('[data-op-global-header]');
    var destroy = header && instances.get(header);
    if (destroy) destroy();
  });
})();
